import { OtherItemsList } from '@/imports/ui/admin/pages/FinancialsPage/components/OtherItems/components/List/OtherItemsList';
import { CartLayout } from '@/layouts/CartLayout';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';
import { Box, Heading } from '@chakra-ui/react';

export default restrictedRoute(() => 

     <CartLayout>
      <Box w="100%" maxW="1200px" mx="auto" p={6}>
        <Box mb={6}>
          <Box mb={4}>
            <Heading as="h1" size="xl">
              Other Items
            </Heading>
            
          </Box>
        </Box>
        <OtherItemsList isMember={true} />
      </Box>
    </CartLayout>

, {
  requiresEvery: [RouteRestrictions.AUTHENTICATION],
});
